(() => {
  if (customElements.get('canalla-depth')) return;
  customElements.define('canalla-depth', class extends HTMLElement {
    connectedCallback() {
      this.controls?.abort();
      this.controls = new AbortController();
      const signal = this.controls.signal;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const pointer = matchMedia('(hover: hover) and (pointer: fine)');
      const reset = () => {
        cancelAnimationFrame(this.frame);
        this.style.removeProperty('--ch-depth-x');
        this.style.removeProperty('--ch-depth-y');
      };
      this.addEventListener('pointermove', event => {
        if (motion.matches || !pointer.matches) return;
        const rect = this.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 16;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 10;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.style.setProperty('--ch-depth-x', x.toFixed(2) + 'px');
          this.style.setProperty('--ch-depth-y', y.toFixed(2) + 'px');
        });
      }, {signal});
      this.addEventListener('pointerleave', reset, {signal});
      motion.addEventListener('change', reset, {signal});
      pointer.addEventListener('change', reset, {signal});
    }
    disconnectedCallback() {
      this.controls?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
})();

(() => {
  if (customElements.get('canalla-benefits')) return;
  customElements.define('canalla-benefits', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (this.classList.contains('is-revealing') ||
          matchMedia('(prefers-reduced-motion: reduce)').matches ||
          !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.classList.add('is-revealing');
        this.observer.disconnect();
      }, {threshold: .2});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
})();
